import { Library } from 'lucide-react';

export function ResourcesHero() {
  return (
    <section className="pt-32 md:pt-40 pb-20 md:pb-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
          Intelligence Library
        </p>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground tracking-tight leading-tight mb-6">
          Intelligence for the Modern Surgical Enterprise.
        </h1>

        <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
          Access our library of clinical white papers, executive briefings, and
          procedure-specific revenue integrity guides.
        </p>
      </div>
    </section>
  );
}
